import { useIonPopover } from '@ionic/react';
import { ReactNode, useEffect } from 'react';

import ActionIconButton from '@components/buttons/ActionIconButton';
import styles from '@components/popovers/Popover.module.css';
import { Opener } from '@hooks/useOpener';
import { IconName } from '@utils/iconUtils';

type Props = {
  buttonContent?: ReactNode;
  children: ReactNode;
  color?: 'shadesWhite' | 'primary700';
  disabled?: boolean;
  icon?: IconName;
  isOpen: boolean;
  opener: Opener;
};

type PopoverContentProps = {
  children: ReactNode;
};

const PopoverContent = ({ children }: PopoverContentProps) => <div className={styles.popover}>{children}</div>;

const Popover = ({ buttonContent, children, color, disabled = false, icon, isOpen, opener }: Props) => {
  const [presentPopover, dismiss] = useIonPopover(<PopoverContent>{children}</PopoverContent>);

  useEffect(() => {
    if (!isOpen) {
      dismiss();
    }
  }, [isOpen, dismiss]);

  if (buttonContent) {
    return (
      <div
        className={disabled ? styles.disabledButton : styles.button}
        onClick={e => {
          if (disabled) return;

          e.preventDefault();
          e.stopPropagation();

          presentPopover({
            alignment: 'center',
            cssClass: styles.popover,
            event: e.nativeEvent,
            showBackdrop: false,
            side: 'bottom'
          });
          opener.open();
        }}
      >
        {buttonContent}
      </div>
    );
  }

  return (
    <ActionIconButton
      ariaLabelKey="accessibility.ariaLabels.actions"
      color={color ?? 'neutral300'}
      data-test="popover-button"
      disabled={disabled}
      icon={icon ?? 'ellipsis'}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();

        presentPopover({
          alignment: 'center',
          cssClass: styles.popover,
          event: e.nativeEvent,
          showBackdrop: false,
          side: 'bottom'
        });
        opener.open();
      }}
      size="medium"
    />
  );
};

export default Popover;
